import * as types from './mutations-types';
import { Auth } from 'aws-amplify';
import { API, graphqlOperation } from 'aws-amplify';
import { updateUserMetadata } from '../../../graphql/mutations';
import { getUserMetadata } from '../../../graphql/queries';
import { getCurUser } from '../../../constants/fromLocalStorageConstants';
import { getAWSDateTime } from '../../../utils/dateUtils';
import { logError } from '@/utils/loggerUtils';

export const actions = {
  async FETCH_USER({ commit }) {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const identityID = (await Auth.currentCredentials()).identityId;
      localStorage.setItem(
        'user',
        JSON.stringify({
          ...user.attributes,
          identityID,
          groups: user.signInUserSession.accessToken.payload['cognito:groups'],
        })
      );
      commit(types.FETCH_USERS_SUCCESS);
    } catch (e) {
      logError(e);
      commit(types.FETCH_USERS_FAILURE);
    }
  },
  async updateMetadata({ commit }, { awsDateTime }) {
    // @TODO DO NOT USE until the UserMetadata table is fully populated
    commit(types.UPDATE_USER_METADATA_STARTED);
    try {
      API.graphql(
        graphqlOperation(updateUserMetadata, {
          input: { id: getCurUser().email, lastLoggedIn: awsDateTime },
        })
      );
      commit(types.UPDATE_USER_METADATA_SUCCESS);
    } catch (e) {
      logError(e);
      commit(types.UPDATE_USER_METADATA_FAILURE);
    }
  },
  async fetchUserMetadata({ commit, dispatch }) {
    commit(types.FETCH_USER_METADATA_STARTED);
    try {
      const res = await API.graphql(
        graphqlOperation(getUserMetadata, { id: getCurUser().email })
      );
      commit(types.FETCH_USER_METADATA_SUCCESS, res.data.getUserMetadata);
    } catch (e) {
      logError(e);
      commit(types.FETCH_USER_METADATA_FAILURE);
    }

    dispatch('updateMetadata', { awsDateTime: getAWSDateTime(false) });
  },
};
